var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePicDecorator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 40,
    fill: "url(#pattern0_106_1278)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_106_1278",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_106_1278",
    transform: "scale(0.037037 0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_106_1278",
    width: 27,
    height: 40,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAoCAMAAAA45HFkAAAAAXNSR0IB2cksfwAAANtQTFRF6W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W86qqNw8wAAAEl0Uk5TWuHy0jkA5f+69c7LzdanO/EEW2upJR7quQJcaKPJN0TQTvBP7e5HM8eld/reanN6aQ8OP0NBRb+ZFRG14ziHPIyNjhzZUF/ICxgc+GEAAADhSURBVHic3dPRC8FAHAfw+2ETDalJhhV59eBBmPKfK4VIHvwHUkiykixDZLO5/e7WPXmRe/p+73O3dV0HBIB8BqDsVhlXeDCWeKIWvTMWkVCL3f7OmLNLV8ZSeGn8wljmGg222YkzNvy7lKWcREYylnIUWda5wYPASM5U9yIjeVM1vZSWedN2NBZ4K21pLPKmr2ks/5DpvFVWNPJnqMISZWxKAYC+Fye4Vn93pywaMA+Wutb8TDQ3a/SVt7VnfmlNCG/G1C+dcciS9pdmjMTWHYasB95cTRuETK172Ir3GXsBlHY8ap8+hFAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicDecorator);
export default __webpack_public_path__ + "static/media/ProfilePicDecorator.0fbe7a7d078e73a51524ea770be4dc9b.svg";
export { ForwardRef as ReactComponent };